import React from 'react';
import { useSelector } from 'react-redux';
import { selectShowOrganisationSuspendedModal } from 'redux/session/selectors';
import { Modal } from 'carbon-components-react';

const OrganisationSuspendedModal: React.FC = () => {
  const showSuspendedOrgModal = useSelector(
    selectShowOrganisationSuspendedModal
  );

  const handleModalCloseButtonClick = () => {
    const { REACT_APP_IDENTITY_WEB_URL = '' } = process.env;
    window.location.href = REACT_APP_IDENTITY_WEB_URL;
  };

  return (
    <Modal
      passiveModal
      onRequestClose={() => {
        handleModalCloseButtonClick();
      }}
      open={showSuspendedOrgModal}
      className={`organisation-suspended-modal`}
      modalHeading="Your account is suspended"
      size="sm"
      preventCloseOnClickOutside
    >
      Please call us on 1300 635 196 or submit a support request by email here{' '}
      <a href="mailto:support@esriaustralia.com.au">
        support@esriaustralia.com.au
      </a>
      .
    </Modal>
  );
};

export default React.memo(OrganisationSuspendedModal);
